import { fontWeights } from "@/utils/fonts";
import AllIconsComponent from "../custom-icons/AllIconsComponent";

interface IndustryCardProps {
  title: string;
  description: string;
  icon: string;
}

export function SoftwareCard({ title, description, icon: Icon }: IndustryCardProps) {
  return (
    <div
      className="
    shadow-[0_4px_20px_rgba(0,0,0,0.1)]
    hover:shadow-[0_8px_30px_rgba(0,0,0,0.3)] 
    transition-shadow
    duration-300
    bg-white 
    md:px-4
    lg:px-[10px]
    xl:px-[18px]
    2xl:px-[26px]
    pb-2
    md:pb-6
    lg:pb-[5px]
    xl:pb-[15px]
    2xl:pb-[21px]
    pt-2
    md:pt-6
    lg:pt-[8px]
    xl:pt-[10px]
    2xl:pt-[15px]
    rounded-[10px] 
    flex 
    flex-col
    items-center 
    text-center 
    group 
    w-auto 
    tsm-400:w-[380px]
    sm:w-[600px]
    lg:w-[230px]
    xl:w-[290px]
    2xl:w-[320px]
    max-w-[800px]
    h-auto
    max-h-auto 
    "
    >
      <div className="">

        <div
          className="
        w-12
        lg:w-[60px]
        xl:w-[100px]
        h-12
        lg:h-[60px]
        xl:h-[100px] 
        flex 
        items-center 
        justify-center 
        mx-auto
        mb-[10px]
        "
        >
          <AllIconsComponent iconName={Icon} height="100" width="100" color="" />
        </div>
        <h3
          className="
        text-[14px]
        sm:text-[17px]
        md:text-[18px] 
        lg:text-[20px] 
        xl:text-[24px]  
        text-[#000000]
        mb-4
        lg:mb-5
        xl:mb-[35px]
        "
          style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.semiBold }}
        >
          {title}
        </h3>
      </div>

      <p
        className="
      text-[#000000] 
      leading-6
      text-[14px]  
      lg:text-[17px] 
      2xl:text-[18px]
      px-10
      tsm-350:px-6
      lg:px-0
      "
        style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.regular }}
      >
        {description}
      </p>
    </div>
  );
}
